// src/realtime/usePGSubscriptionCount.ts
import * as React from "react";
import { getPGBroadcastClient, pgActiveSubCount } from "./pgbroadcastSingleton";

export function usePGSubscriptionCount(pollMs = 750): number {
  const [count, setCount] = React.useState(() => pgActiveSubCount());

  React.useEffect(() => {
    // update on any message (cheap) + polling as a fallback
    const c = getPGBroadcastClient();
    const off = c.onMessage(() => setCount(pgActiveSubCount()));

    const id = window.setInterval(() => {
      setCount(pgActiveSubCount());
    }, pollMs);

    return () => {
      off();
      window.clearInterval(id);
    };
  }, [pollMs]);

  return count;
}
